// extracted by mini-css-extract-plugin
export default {"action-btn":"HealthDenialOne--action-btn--jGkh0","actionBtn":"HealthDenialOne--action-btn--jGkh0"};